'use strict';

import React, {useEffect, useState} from "react";
import { createRoot } from "react-dom/client";
import { createPortal } from "react-dom";
import { CartProvider } from "../../common/CartContext";
import ProductCartButtons from "./ProductCartButtons";
import ShoppingCart from "./ShoppingCart";

export default function Cart() {
  const [cartButtons, setCartButtons] = useState(Array.from(document.getElementsByClassName('cart-buttons')));

  useEffect(() => {
    document.addEventListener('drupalAjaxDone', (event) => {
      setCartButtons(Array.from(document.getElementsByClassName('cart-buttons')));
    });
  }, [cartButtons]);

  return (
    <CartProvider>
      {document.getElementById('shopping-cart-root') && (
        createPortal(
          <ShoppingCart />,
          document.getElementById('shopping-cart-root')
        )
      )}

      {cartButtons.length !== 0 &&
        cartButtons.map((element) => {
          let nsProductId = element.dataset.nsid;
          let nid = element.dataset.nid;
          let icon = element.dataset.icon;
          let name = element.dataset.name;
          let unitPrice = element.dataset.price;
          let key = "cart_" + nid;

          return createPortal(
            <ProductCartButtons
              nsProductId={nsProductId}
              nid={nid}
              icon={icon}
              name={name}
              unitPrice={unitPrice}
            />,
            element,
            key
          )
        })}
    </CartProvider>
  );
}

let cartElement = document.getElementById("cart-root");
if (cartElement) {
  const cartRoot = createRoot(cartElement);
  cartRoot.render(<Cart />)
}
